import { openDrawer, closeDrawer } from '../../drawer';
import { initBackButtons } from './shared'
import { selectors } from './selectors'
import { addVariantToCart } from './drawer-product'

export const initQuantity = () => {
  const plus = document.querySelector('[js-quantity-plus]')
  const minus = document.querySelector('[js-quantity-minus]')
  const input = document.querySelector('[js-drawer-quantity-input]')
  const buyBtn = document.querySelector('[js-buy-button]')
  
  const handleInput = n => {
    const inventoryPolicy = document.querySelector('[js-inventory-policy]')?.getAttribute('js-inventory-policy');
    const inventory = parseInt(plus.getAttribute('data-inventory'));
    const value = parseInt(input.getAttribute('value')) + n;
    input.innerHTML = value;
    input.setAttribute('value', value);
    buyBtn.removeAttribute('disabled');

    if (value === inventory && inventoryPolicy === 'deny') {
      plus.classList.add('is-disabled');
    } else {
      plus.classList.remove('is-disabled');
    }
  }

  const initAvailable = (n = 0) => {
    const inventoryPolicy = document.querySelector('[js-inventory-policy]')?.getAttribute('js-inventory-policy');
    const inventory = parseInt(plus.getAttribute('data-inventory'));
    const value = parseInt(input.getAttribute('value')) + n;

    if (value === inventory && inventoryPolicy === 'deny') {
      plus.classList.add('is-disabled');
    } else {
      plus.classList.remove('is-disabled');
    }

    if (value > inventory && inventoryPolicy === 'deny') {
      buyBtn.setAttribute('disabled', '');
      return false;
    }

    return true;
  }

  if (!plus) return
  plus.addEventListener('click', () => {
    if (initAvailable(1)) {
      handleInput(1);
    }
  })

  if (!minus) return
  minus.addEventListener('click', () => {
    const value = parseInt(input.getAttribute('value'))
    if (value > 1) handleInput(-1)
  })

  initAvailable()
}

export const fetchDrawerWidthVariants = async handle => {
  const url = location.origin + "/products/" + handle + "?view=atc-drawer-with-variants"
  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }
  const data = await response.text()
  return data
}
 
export const renderAtcDrawerWithVariants = async handle => {
  return new Promise(async (resolve, reject) => {
    try {
      const data = await fetchDrawerWidthVariants(handle);
      const drawerElement = document.querySelector('[data-js-selector="atc-product"]')
      const parsedData = new DOMParser().parseFromString(data, 'text/html')
      drawerElement.innerHTML = parsedData.querySelector('[data-js-selector="atc-product"]').innerHTML
      drawerElement.classList.add('drawer--atc__variants')
      setTimeout(() => {
        openDrawer(drawerElement)
        resolve(drawerElement);
      }, 300)
    } catch (error) {
      console.error("Error:", error);
      reject(error);
    }
  });
};

const initBuyButton = () => {
  const buyBtn = document.querySelector('[js-buy-button]')
  buyBtn.addEventListener('click', async e => {
    const id = buyBtn.getAttribute('data-variant-id')
    const quantity = document.querySelector('[js-drawer-quantity-input]').getAttribute('value')

    addVariantToCart(buyBtn, quantity, id)
  })
}

export const variantSelectorDrawer = async handle => {
  debugger;
  await renderAtcDrawerWithVariants(handle).then((drawerElement) => {
    initBuyButton()
    initQuantity()
    initBackButtons()
    const selectorScript = drawerElement.querySelector('[data-variant-selector-script]');
    const drawerVariant = true;
    const scriptContent = `const drawerVariant = ${JSON.stringify(drawerVariant)};\n` + selectorScript.innerHTML;
    eval(scriptContent);
  }).catch(error => {
    console.error("Error:", error);
  })
}

const addVariantsSelectorChangeListener = () => {
  window.addEventListener('message', function(event) {
    if (event.data.type === 'variantsSelectorChange') {
      initBuyButton()
      initQuantity()
      initBackButtons()
    }
  })
}

const initBuyButtons = () => {
  const selectVariantButtons = document.querySelectorAll(selectors.atcProductWithVariantsButton)

  selectVariantButtons.forEach(btn => {
    btn.addEventListener('click', async e => {
      variantSelectorDrawer(btn.getAttribute('js-atc-product-with-variants'))

    })
  })
}

initBuyButtons();
addVariantsSelectorChangeListener();